import { render, staticRenderFns } from "./arrange.vue?vue&type=template&id=618c5fb6&scoped=true&"
import script from "./arrange.vue?vue&type=script&lang=js&"
export * from "./arrange.vue?vue&type=script&lang=js&"
import style0 from "./arrange.vue?vue&type=style&index=0&id=618c5fb6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "618c5fb6",
  null
  
)

export default component.exports